import _ from 'lodash'

/**
 * Given a Backbone Model returns the "Client Id" pattern used in reports to
 * handle both persisted and unpersisted models
 */
function clientId(model) {
	return _.isNil(model.attributes.id) ? model.attributes.cid : model.attributes.id
}

export default clientId

clientId.__filename__ = 'reports/common/model/designer-client-id.js'
